
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import keycode from 'keycode';

/**
 * List components
 * TODO:
 *  - borders (spec not clear about borders)
 *  - condensed
 */
export var List = function List(_ref) {
  var children = _ref.children,
      style = _ref.style;

  return React.createElement(
    'ol',
    { className: 'mdc-List', style: style },
    children
  );
};

export var Row = function Row(_ref2) {
  var avatar = _ref2.avatar,
      className = _ref2.className,
      icon = _ref2.icon,
      onBlur = _ref2.onBlur,
      onClick = _ref2.onClick,
      onFocus = _ref2.onFocus,
      primary = _ref2.primary,
      secondary = _ref2.secondary,
      style = _ref2.style,
      subheader = _ref2.subheader;

  var onKeyDown = function onKeyDown(event) {
    if (event.which === keycode('down') && event.target.nextSibling) {
      event.preventDefault();
      event.target.nextSibling.focus();
    } else if (event.which === keycode('up') && event.target.previousSibling) {
      event.preventDefault();
      event.target.previousSibling.focus();
    }
  };

  var avatarElement = avatar && React.createElement(
    'div',
    { className: 'mdc-List-row-avatar', key: 'avatar' },
    typeof avatar === 'string' ? React.createElement('img', { src: avatar }) : avatar
  );

  var iconLeftElement = !avatar && icon && React.createElement(
    'div',
    { className: 'mdc-List-row-icon-left', key: 'icon-left' },
    icon
  );

  var iconRightElement = avatar && icon && React.createElement(
    'div',
    { className: 'mdc-List-row-icon-right', key: 'icon-right' },
    icon
  );

  var isSelectable = onFocus || onBlur;

  var dynamicClasses = {
    'mdc-List-row--oneline': !secondary && !subheader,
    'mdc-List-row--twoline': secondary && !subheader,
    'mdc-List-row--threeline': secondary && subheader,
    'mdc-List-row--selectable': isSelectable
  };

  var textElement = React.createElement(
    'div',
    { className: 'mdc-List-row-text', key: 'text' },
    React.createElement(
      'div',
      { className: 'mdc-List-row-text-primary' },
      primary
    ),
    subheader && React.createElement(
      'div',
      { className: 'mdc-List-row-text-subheader' },
      subheader
    ),
    secondary && React.createElement(
      'span',
      { className: 'mdc-List-row-text-secondary' },
      secondary
    )
  );

  var rowContent = [avatarElement, iconLeftElement, textElement, iconRightElement];
  var rowProps = {
    className: classNames('mdc-List-row', dynamicClasses, className),
    onClick: onClick,
    style: style,
    onKeyDown: onKeyDown,
    onFocus: onFocus,
    onBlur: onBlur,
    tabIndex: isSelectable ? '0' : null
  };
  return React.createElement(
    'li',
    rowProps,
    rowContent
  );
};

var stringOrElement = function stringOrElement() {
  return PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element), PropTypes.string]);
};

Row.propTypes = {
  avatar: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  className: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  primary: stringOrElement().isRequired,
  secondary: stringOrElement(),
  style: PropTypes.object,
  subheader: stringOrElement()
};


//////////////////
// WEBPACK FOOTER
// ../es/js/list/index.js
// module id = 287
// module chunks = 0